export default __webpack_public_path__ + "static/media/shield-icon.a8530cf0.svg";